import { useQuery } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { clientKeys } from './client.key';

export function useGetClient() {
  const getApi = useApi();

  const getClient = async () => {
    const api = await getApi();

    const res = await api.clientsGetClient();
    return res.data;
  };

  const query = useQuery({
    queryKey: clientKeys.me,
    queryFn: getClient,
    keepPreviousData: true,
  });

  return {
    ...query,
  };
}
